<template>
  <section>
    <div class="home">
      <!-- 导航栏 -->
      <nav class="navbar">
        <div class="logo">NEXAVERSE</div>
        <!-- <div class="nav-links">
          <router-link to="/">首页</router-link>
          <router-link to="/google">Google营销</router-link>
          <router-link to="/bing">Bing营销</router-link>
          <router-link to="/criteo">Criteo营销</router-link>
          <router-link to="/facebook">Facebook营销</router-link>
          <router-link to="/about">关于我们</router-link>
        </div>
        <button class="open-account">开户试投</button>-->
      </nav>

      <!-- 主要内容区 -->
      <div class="hero-section">
        <div class="hero-content">
          <!-- <h1>重力科技</h1> -->
          <h2>海外广告一站式服务专家</h2>
          <p>深耕海外广告行业15年，助力万家企业海外获客增长</p>
          <!-- <button class="try-now">开户试投</button> -->
        </div>

        <!-- 服务特点卡片 -->
        <div class="service-cards">
          <div class="service-card">
            <div class="card-icon">
              <i class="fas fa-user-plus"></i>
            </div>
            <h3>海外广告开户</h3>
            <p>开户试投，专人对接</p>
          </div>
          <div class="service-card">
            <div class="card-icon">
              <i class="fas fa-chart-line"></i>
            </div>
            <h3>优化媒体配置</h3>
            <p>在展现低，转化提升</p>
          </div>
          <div class="service-card">
            <div class="card-icon">
              <i class="fas fa-shield-alt"></i>
            </div>
            <h3>资深代投服务</h3>
            <p>官方认证，行业认可</p>
          </div>
          <div class="service-card">
            <div class="card-icon">
              <i class="fas fa-tools"></i>
            </div>
            <h3>智能营销工具</h3>
            <p>降本增效，助力获客</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加认证信息展示区 -->
    <div class="certification-section">
      <h2>拥有全球海量媒介资源，官方认可广告代理商</h2>
      <p class="sub-desc">Google中国区官方代理商、微软广告（原必应广告）官方代理商、Criteo中国区官方代理商、Meta中国区十年优选合作伙伴</p>

      <div class="achievement-list">
        <div class="achievement-item">
          <i class="fas fa-globe"></i>
          <span>20家海外媒体资源</span>
        </div>
        <div class="achievement-item">
          <i class="fas fa-chart-line"></i>
          <span>15年跨境行业深耕</span>
        </div>
        <div class="achievement-item">
          <i class="fas fa-users"></i>
          <span>1W+企业服务经验</span>
        </div>
        <div class="achievement-item">
          <i class="fas fa-building"></i>
          <span>18家全球分公司</span>
        </div>
        <div class="achievement-item">
          <i class="fas fa-user-tie"></i>
          <span>200人客户服务团队</span>
        </div>
        <div class="achievement-item">
          <i class="fas fa-handshake"></i>
          <span>30家生态合作伙伴</span>
        </div>
      </div>
    </div>

    <!-- 添加定制方案区 -->
    <div class="solution-section">
      <h2>为出海企业量身定制海外拓客、增长解决方案</h2>
      <p class="solution-desc">资深服务团队+成熟服务体系，满足每位客户从调研、策划、创意、设计、数据、口碑等多元化出海需求</p>

      <div class="service-intro-section">
        <div class="service-intro-grid">
          <div
            v-for="(service, index) in services"
            :key="index"
            class="service-item"
            :class="{ active: currentService === index }"
            @mouseenter="currentService = index"
          >
            <div class="service-icon">
              <i :class="service.icon"></i>
            </div>
            <h3>{{ service.title }}</h3>
          </div>
        </div>

        <div class="service-detail">
          <div class="service-detail-content">
            <div class="service-icon-large">
              <i :class="services[currentService].icon"></i>
            </div>
            <h3>{{ services[currentService].title }}</h3>
            <p>{{ services[currentService].description }}</p>
            <div class="service-features">
              <p>{{ services[currentService].features }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="marketing-tools-section">
      <h2>简单易用的智能营销工具，助力出海企业"降本增效"</h2>
      <p class="tools-desc">开户、充值、查询、投放、申诉、监测等功能一体化</p>

      <div class="tools-feature">
        <div class="feature-content">
          <div class="tools-grid">
            <div
              v-for="(tool, index) in tools"
              :key="index"
              class="tool-item"
              :class="{ active: currentTool === index }"
              @mouseenter="currentTool = index"
            >
              <i :class="tool.icon"></i>
              <span>{{ tool.title }}</span>
            </div>
          </div>
        </div>

        <div class="tools-preview">
          <div class="tool-detail">
            <div class="feature-title">
              <i :class="tools[currentTool].icon"></i>
              <h3>{{ tools[currentTool].title }}</h3>
            </div>
            <p class="feature-desc" v-html="tools[currentTool].description"></p>
          </div>
          <img :src="tools[currentTool].image" :alt="tools[currentTool].title" />
        </div>
      </div>
    </div>

    <div class="industry-advantages-section">
      <h2>八大行业优势，为跨境企业全方位保驾护航</h2>
      <p class="advantages-desc">15年行业深耕，沉淀海外拓客方法论及大数据，专注为出海企业提供增加外广告一站式服务</p>

      <div class="advantages-container">
        <div class="advantages-left">
          <div class="service-time">
            <i class="fas fa-headset"></i>
            <h3>7x24小时</h3>
            <h4>为出海企业护航</h4>
            <p>15年行业深耕，沉淀海外拓客方法论及大数据，专注为跨境企业提供全链路出海解决方案</p>
            <button class="contact-btn">免费咨询</button>
          </div>
        </div>

        <div class="advantages-grid">
          <div class="advantage-item">
            <i class="fas fa-check-circle"></i>
            <div class="advantage-content">
              <h4>官方认可广告代理</h4>
              <p>一手资源渠道专稳定</p>
            </div>
          </div>
          <div class="advantage-item">
            <i class="fas fa-chart-pie"></i>
            <div class="advantage-content">
              <h4>购物旺季总结分享</h4>
              <p>合理配置成本增效</p>
            </div>
          </div>
          <div class="advantage-item">
            <i class="fas fa-users-cog"></i>
            <div class="advantage-content">
              <h4>媒体官方资源支持</h4>
              <p>原厂渠道经理扶持</p>
            </div>
          </div>
          <div class="advantage-item">
            <i class="fas fa-star"></i>
            <div class="advantage-content">
              <h4>成熟业务服务体系</h4>
              <p>管家式心贴心服务</p>
            </div>
          </div>
          <div class="advantage-item">
            <i class="fas fa-tools"></i>
            <div class="advantage-content">
              <h4>自助智能营销工具</h4>
              <p>简单易用效率提升</p>
            </div>
          </div>
          <div class="advantage-item">
            <i class="fas fa-credit-card"></i>
            <div class="advantage-content">
              <h4>支持多种付款方式</h4>
              <p>广告消耗实时可查</p>
            </div>
          </div>
          <div class="advantage-item">
            <i class="fas fa-user-check"></i>
            <div class="advantage-content">
              <h4>可供选择代投服务</h4>
              <p>规避风险避免损失</p>
            </div>
          </div>
          <div class="advantage-item">
            <i class="fas fa-chart-bar"></i>
            <div class="advantage-content">
              <h4>行业营销实战案例</h4>
              <p>精准洞察行业趋势</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="media-partners-section">
      <h2>随时获取媒体官方渠道经理全方位产品培训和技术支持</h2>

      <div class="partners-grid">
        <div class="partner-card">
          <img src="../assets/logo_gg.png" alt="Google" />
          <h3>Google中国区官方代理商</h3>
          <ul>
            <li>
              <i class="fas fa-check"></i>
              可提供专属Google官方渠道经理和客户支持团队提供服务
            </li>
            <li>
              <i class="fas fa-check"></i>
              策略游戏、APP行业、消费品牌求、打造爆款游戏及APP
            </li>
          </ul>
          <!-- <button class="learn-more">查看更多</button> -->
        </div>

        <div class="partner-card">
          <img src="../assets/logo_bing.png" alt="Microsoft" />
          <h3>微软广告（原Bing广告）中国区官方代理商</h3>
          <ul>
            <li>
              <i class="fas fa-check"></i>
              第一时间获取官方渠道经理，技术专家培训与指导
            </li>
            <li>
              <i class="fas fa-check"></i>
              专属购物旺季活动分享，合理配置营销本增效
            </li>
          </ul>
          <!-- <button class="learn-more">查看更多</button> -->
        </div>

        <div class="partner-card">
          <img src="../assets/logo_criteo.png" alt="Criteo" />
          <h3>Criteo中国区官方代理商</h3>
          <ul>
            <li>
              <i class="fas fa-check"></i>
              一对一渠道经理指导
            </li>
            <li>
              <i class="fas fa-check"></i>
              本土专门团队负责支持，包括：广告账户搭建、代码安装、创意素材设计等
            </li>
          </ul>
          <!-- <button class="learn-more">查看更多</button> -->
        </div>

        <div class="partner-card">
          <img src="../assets/logo_fb.png" alt="Meta" />
          <h3>Meta中国区十年优选合作伙伴</h3>
          <ul>
            <li>
              <i class="fas fa-check"></i>
              基于Meta资源和产品，提供广告开户、广告代投、素材制作、智能工具等专业服务及产品
            </li>
          </ul>
          <!-- <button class="learn-more">查看更多</button> -->
        </div>
      </div>
    </div>

    <div class="success-cases-section">
      <h2>成功助力10000+企业海外获客，知名品牌合作伙伴</h2>
      <p class="cases-desc">每年为中国跨境企业实现海外增长1000亿次</p>

      <div class="industry-types">
        <div class="type-item">
          <i class="fas fa-mobile-alt"></i>
          <span>APP</span>
        </div>
        <div class="type-item">
          <i class="fas fa-gamepad"></i>
          <span>游戏</span>
        </div>
        <div class="type-item">
          <i class="fas fa-shopping-bag"></i>
          <span>电商</span>
        </div>
        <div class="type-item">
          <i class="fas fa-network-wired"></i>
          <span>互联网平台</span>
        </div>
      </div>

      <!-- <div class="partner-brands">
        <el-carousel :interval="3000" arrow="always" indicator-position="none" height="80px">
          <el-carousel-item v-for="(group, index) in brandGroups" :key="index">
            <div class="brand-group">
              <img
                v-for="(brand, brandIndex) in group"
                :key="brandIndex"
                :src="brand.logo"
                :alt="brand.name"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div> -->
    </div>

    <footer class="footer-section">
      <div class="footer-content">
        <!-- <div class="footer-links">
          <div class="link-group">
            <h3>海外广告开户</h3>
            <ul>
              <li>
                <router-link to="/google">Google广告开户</router-link>
              </li>
              <li>
                <router-link to="/bing">Bing广告开户</router-link>
              </li>
              <li>
                <router-link to="/criteo">Criteo广告开户</router-link>
              </li>
              <li>
                <router-link to="/facebook">Facebook广告开户</router-link>
              </li>
            </ul>
          </div>
        </div> -->

        <div class="footer-links">
          <div class="link-group">
            <h3>联系我们</h3>
            <ul>
              <li>联系我们: +852-70184341</li>
              <li>市场合作: nexaverse_client@yeah.net</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- <div class="footer-bottom">
        <p>天津重力科技服务有限公司 © 版权所有 2026 津ICP备20240240240号</p>
      </div>-->
    </footer>
  </section>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      brandGroups: this.getBrandGroups(),
      currentService: 0, // 当前选中的服务索引
      services: [
        {
          icon: "fas fa-bullhorn",
          title: "广告采买服务",
          description: "",
          features:
            "以Google、Bing、Criteo、Facebook为主的20+海外主流媒体广告采买服务,1V1全程手把手指导，7x24小时在线服务，24小时内下户支持线上自助充值，实时到账，消耗可查"
        },
        {
          icon: "fas fa-handshake",
          title: "媒体官方支持",
          description: "",
          features:
            "Google、Bing、Criteo官方渠道经理、技术专家培训与指导来自官方团队的支持，包括：广告账户建设、监测代码安装、创意素材设计等"
        },
        {
          icon: "fas fa-lightbulb",
          title: "定制投放策略",
          description: "",
          features:
            "根据出海企业的业务类型、发展阶段，提供调研及诊断服务制定因地制宜的出海策略、媒体配置方案熟悉各国出海政策，提前规避风险"
        },
        {
          icon: "fas fa-cogs",
          title: "代客运营拓客",
          description: "",
          features: `15年以上专家优化师带队，团队均有Google Guru认证、Microsoft Advertising Search认证、Meta Blue Print认证
账户搭建、广告上线、竞价调整、数据监测等一站式代投服务
多项电商、游戏、应用行业明星级案例，策划营销活动，实现多次复购`
        },
        {
          icon: "fas fa-chart-bar",
          title: "数据分析复盘",
          description: "",
          features:
            "周期提供广告效果周报、月报、季报，广告数据留存，赋能二次营销。周期提供行业报告、友商报告， 给予业务发展决策性参考"
        }
      ],
      currentTool: 0,
      tools: [
        // {
        //   icon: "fas fa-ad",
        //   title: "自助广告开户充值",
        //   description: "对接媒体API接口<br/>轻松自助完成开户、充值、授权绑定，广告消耗实时可查",
        //   image: require("../assets/saas_1.png")
        // },
        {
          icon: "fas fa-ad",
          title: "广告账号统一管理",
          description: "Facebook广告账号统一管理，无需切换，一个页面搞定全部广告BM授权模式可以代替登录个号管理主页，摆脱个号上广告的限制",
          image: require("../assets/saas_2.png")
        },
        {
          icon: "fas fa-shield-alt",
          title: "规避账号违规风险",
          description: "拥有全行业知识库、违规词，避免广告下线<br/>实时监控Facebook主页健康状态，预警风险",
          image: require("../assets/saas_3.png")
        },
        {
          icon: "fas fa-chart-line",
          title: "实时监测广告数据",
          description: "实时监测广告投放效果，将低效广告再优化<br/>多维度用户分析看板，找到Ta就是这么简单<br/>满足广告成效数据横向对比，辅助投放决策",
          image: require("../assets/saas_4.png")
        },
        {
          icon: "fas fa-shopping-cart",
          title: "一键店铺商品搬家",
          description: "支持Shopline、Shopify、店匠等独立站平台",
          image: require("../assets/saas_5.png")
        }
      ]
    };
  },
  methods: {
    getBrandGroups() {
      // 使用 require.context 动态导入 banner 目录下的所有图片
      const bannerContext = require.context(
        "../assets/banner",
        false,
        /\.(png|jpe?g|svg)$/
      );
      const brandImages = bannerContext.keys().map(key => ({
        logo: bannerContext(key),
        name: key.replace(/^\.\//, "").replace(/\.(png|jpe?g|svg)$/, "")
      }));
      console.log(brandImages);
      // 将图片每3个分为一组
      const groups = [];
      for (let i = 0; i < brandImages.length; i += 5) {
        groups.push(brandImages.slice(i, i + 5));
      }

      return groups;
    }
  }
};
</script>

<style scoped>
.home {
  width: 100%;
  min-height: 85vh;
  background: linear-gradient(135deg, #fff5f0 0%, #fff 100%);
  background-image: url("../assets/wrapper_1_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

/* 添加一个半透明遮罩，确保文字清晰可见 */
.home::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  z-index: 1;
}

/* 确保内容在遮罩层之上 */
.navbar,
.hero-section {
  position: relative;
  z-index: 2;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 50px;
  background: transparent;
}

.logo {
  font-size: 24px;
  font-weight: bold;
  color: #ff6b35;
}

.nav-links {
  display: flex;
  gap: 30px;
}

.nav-links a {
  text-decoration: none;
  color: #333;
  font-size: 16px;
}

.open-account {
  background: #ff6b35;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.hero-section {
  padding: 60px 50px;
  text-align: center;
}

.hero-content {
  margin-bottom: 60px;
}

.hero-content h1 {
  font-size: 48px;
  margin-bottom: 20px;
  color: #333;
  font-weight: 700; /* 加粗主标题 */
}

.hero-content h2 {
  font-size: 36px;
  margin-bottom: 20px;
  color: #333;
  font-weight: 600; /* 加粗副标题 */
}

.hero-content p {
  font-size: 18px;
  color: #666;
  margin-bottom: 30px;
  font-weight: 500; /* 稍微加重描述文字 */
}

.service-card h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #333;
  font-weight: 600; /* 加粗服务卡片标题 */
}

.service-card p {
  color: #666;
  font-size: 14px;
  font-weight: 400; /* 保持正常字重 */
}

.nav-links a {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500; /* 导航链接稍微加重 */
}

.try-now {
  background: #ff6b35;
  color: white;
  border: none;
  padding: 15px 30px;
  border-radius: 5px;
  font-size: 18px;
  cursor: pointer;
}

.service-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  /* padding: 0 50px; */
}

.service-card {
  background: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
}

.card-icon {
  width: 60px;
  height: 60px;
  background: #fff5f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}

.card-icon i {
  color: #ff6b35;
  font-size: 24px;
}

.service-card h3 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #333;
}

.service-card p {
  color: #666;
  font-size: 14px;
}
</style>

<style lang="less" scoped>
.certification-section {
  padding: 80px 50px;
  text-align: left; // 改为左对齐
  position: relative;
  z-index: 2;
  background: url(../assets/wrapper_2_bg.png) no-repeat 100%;

  h2 {
    font-size: 32px;
    font-weight: 800; // 加重标题字体
    color: #333;
    margin-bottom: 20px;
    width: 50%; // 设置宽度为70%
  }

  .sub-desc {
    font-size: 16px;
    color: #666;
    width: 50%; // 设置宽度为70%
    margin: 0 0 50px; // 移除水平方向的auto
    line-height: 1.6;
    font-weight: 600; // 加重描述文字
  }

  .achievement-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    width: 50%; // 设置宽度为70%
    margin: 0; // 移除水平方向的auto

    .achievement-item {
      background: #fff;
      padding: 24px;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
      display: flex;
      align-items: center;
      gap: 15px;

      i {
        font-size: 24px;
        color: #ff6b35;
      }

      span {
        font-size: 16px;
        color: #333;
        font-weight: 600; // 加重成就项文字
      }
    }
  }
}

.solution-section {
  padding: 80px 50px;
  text-align: center;
  background: #f8f9fa;
  position: relative;
  z-index: 2;

  h2 {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
  }

  .solution-desc {
    font-size: 16px;
    color: #333;
    max-width: 900px;
    margin: 0 auto 30px auto;
    line-height: 1.6;
    font-weight: 600;
  }
}

.service-intro-section {
  padding: 60px 50px;
  background: #fff;

  .service-intro-grid {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-bottom: 40px;

    .service-item {
      flex: 1;
      text-align: center;
      padding: 20px;
      cursor: pointer;
      border-radius: 8px;
      transition: all 0.3s ease;

      &.active {
        background: #fff5f0;
        .service-icon {
          transform: scale(1.1);
        }
        h3 {
          color: #ff6b35;
        }
      }

      .service-icon {
        width: 60px;
        height: 60px;
        margin: 0 auto 15px;
        transition: transform 0.3s ease;

        i {
          font-size: 28px;
          color: #ff6b35;
        }
      }

      h3 {
        font-size: 16px;
        color: #333;
        font-weight: 500;
      }
    }
  }

  .service-detail {
    background: #ff6b35;
    border-radius: 12px;
    padding: 40px;
    color: #fff;

    .service-detail-content {
      width: 70%;
      margin: 0 auto;
      text-align: center;

      .service-icon-large {
        width: 80px;
        height: 80px;
        margin: 0 auto 20px;

        i {
          font-size: 40px;
          color: #fff;
        }
      }

      h3 {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 15px;
      }

      p {
        font-size: 16px;
        line-height: 1.6;
        margin-bottom: 20px;
      }

      .service-features {
        background: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        padding: 20px;
        text-align: left;

        p {
          margin: 0;
          font-size: 14px;
        }
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 1200px) {
  .service-intro-section {
    .service-intro-grid {
      flex-wrap: wrap;
      .service-item {
        flex: 0 0 calc(33.33% - 20px);
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .service-intro-section {
    padding: 40px 20px;

    .service-intro-grid {
      .service-item {
        flex: 0 0 calc(50% - 20px);
      }
    }

    .service-detail {
      .service-detail-content {
        width: 90%;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .service-intro-section {
    .service-intro-grid {
      .service-item {
        flex: 0 0 100%;
      }
    }
  }
}

.marketing-tools-section {
  padding: 80px 50px;
  background: #fff;

  h2 {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
    text-align: center;
  }

  .tools-desc {
    font-size: 16px;
    color: #666;
    margin-bottom: 50px;
    text-align: center;
  }

  .tools-feature {
    display: flex;
    gap: 40px;
    max-width: 1200px;
    margin: 0 auto;

    .feature-content {
      flex: 0 0 300px;

      .tools-grid {
        display: grid;
        grid-template-columns: 1fr;
        gap: 20px;

        .tool-item {
          background: #f8f9fa;
          padding: 20px;
          border-radius: 8px;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;

          &.active {
            background: #fff5f0;
            transform: translateX(5px);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

            i {
              transform: scale(1.1);
            }
          }

          i {
            font-size: 24px;
            color: #ff6b35;
            margin-bottom: 10px;
            display: block;
            transition: transform 0.3s ease;
          }

          span {
            font-size: 14px;
            color: #333;
            font-weight: 500;
          }
        }
      }
    }

    .tools-preview {
      flex: 1;

      .tool-detail {
        background: #fff;
        padding: 30px;
        border-radius: 12px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        margin-bottom: 30px;

        .feature-title {
          display: flex;
          align-items: center;
          gap: 15px;
          margin-bottom: 20px;

          i {
            font-size: 24px;
            color: #ff6b35;
          }

          h3 {
            font-size: 24px;
            color: #333;
            font-weight: 600;
          }
        }

        .feature-desc {
          color: #666;
          font-size: 16px;
          line-height: 1.6;
          text-align: left;
        }
      }

      img {
        width: 100%;
        border-radius: 8px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 992px) {
  .marketing-tools-section {
    .tools-feature {
      flex-direction: column;

      .feature-content {
        flex: none;
        width: 100%;

        .tools-grid {
          grid-template-columns: repeat(2, 1fr);
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .marketing-tools-section {
    padding: 40px 20px;

    .tools-feature {
      .feature-content {
        .tools-grid {
          grid-template-columns: 1fr;
        }
      }
    }
  }
}

.industry-advantages-section {
  padding: 80px 50px;
  background: #f8f9fa;

  h2 {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    text-align: center;
    margin-bottom: 20px;
  }

  .advantages-desc {
    font-size: 16px;
    color: #666;
    text-align: center;
    margin-bottom: 50px;
    max-width: 800px;
    margin: 0 auto 50px;
  }

  .advantages-container {
    display: flex;
    gap: 30px;
    max-width: 1200px;
    margin: 0 auto;

    .advantages-left {
      flex: 0 0 300px;

      .service-time {
        background: #ff6b35;
        padding: 40px 30px;
        border-radius: 12px;
        color: #fff;
        text-align: center;

        i {
          font-size: 40px;
          margin-bottom: 20px;
        }

        h3 {
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 10px;
        }

        h4 {
          font-size: 20px;
          margin-bottom: 20px;
        }

        p {
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 30px;
        }

        .contact-btn {
          background: #fff;
          color: #ff6b35;
          border: none;
          padding: 10px 30px;
          border-radius: 5px;
          font-size: 16px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.3s ease;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }

    .advantages-grid {
      flex: 1;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 20px;

      .advantage-item {
        background: #fff;
        padding: 30px;
        border-radius: 8px;
        display: flex;
        align-items: flex-start;
        gap: 15px;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-5px);
          box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        }

        i {
          font-size: 24px;
          color: #ff6b35;
        }

        .advantage-content {
          h4 {
            font-size: 18px;
            color: #333;
            font-weight: 600;
            margin-bottom: 8px;
          }

          p {
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 992px) {
  .industry-advantages-section {
    .advantages-container {
      flex-direction: column;

      .advantages-left {
        flex: none;
        width: 100%;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .industry-advantages-section {
    padding: 40px 20px;

    .advantages-container {
      .advantages-grid {
        grid-template-columns: 1fr;
      }
    }
  }
}

.media-partners-section {
  padding: 80px 50px;
  background: #fff;

  h2 {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    text-align: center;
    margin-bottom: 50px;
  }

  .partners-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    max-width: 1200px;
    margin: 0 auto;

    .partner-card {
      background: #fff;
      border-radius: 12px;
      padding: 30px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      }

      img {
        height: 40px;
        margin-bottom: 20px;
        object-fit: contain;
      }

      h3 {
        font-size: 18px;
        color: #333;
        font-weight: 600;
        margin-bottom: 20px;
        min-height: 54px;
      }

      ul {
        list-style: none;
        padding: 0;
        margin: 0 0 30px 0;

        li {
          display: flex;
          gap: 10px;
          margin-bottom: 15px;
          font-size: 14px;
          color: #666;
          line-height: 1.6;

          i {
            color: #ff6b35;
            margin-top: 4px;
          }
        }
      }

      .learn-more {
        background: transparent;
        border: 1px solid #ff6b35;
        color: #ff6b35;
        padding: 8px 20px;
        border-radius: 5px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          background: #ff6b35;
          color: #fff;
        }
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 1200px) {
  .media-partners-section {
    .partners-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@media screen and (max-width: 768px) {
  .media-partners-section {
    padding: 40px 20px;

    .partners-grid {
      grid-template-columns: 1fr;
    }
  }
}

.success-cases-section {
  padding: 80px 50px;
  background: #fff;
  text-align: center;

  h2 {
    font-size: 32px;
    font-weight: 700;
    color: #333;
    margin-bottom: 20px;
  }

  .cases-desc {
    font-size: 16px;
    color: #666;
    margin-bottom: 50px;
  }

  .industry-types {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-bottom: 60px;

    .type-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      padding: 30px;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
      min-width: 200px;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
      }

      i {
        font-size: 32px;
        color: #ff6b35;
      }

      span {
        font-size: 18px;
        color: #333;
        font-weight: 500;
      }
    }
  }

  .partner-brands {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 40px;

    .brand-group {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 60px;
      height: 100%;

      img {
        height: 60px;
        object-fit: contain;
        transition: all 0.3s ease;
        background: #fff;

        &:hover {
          filter: grayscale(0);
          opacity: 1;
        }
      }
    }
  }
}

// 响应式适配
@media screen and (max-width: 992px) {
  .success-cases-section {
    .industry-types {
      flex-wrap: wrap;
      gap: 20px;

      .type-item {
        flex: 0 0 calc(50% - 10px);
        min-width: auto;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .success-cases-section {
    padding: 40px 20px;

    .industry-types {
      .type-item {
        flex: 0 0 100%;
      }
    }

    .partner-brands {
      .brand-scroll {
        flex-wrap: wrap;
        justify-content: center;
      }
    }
  }
}

.footer-section {
  background: #333;
  padding: 60px 50px 20px;
  color: #fff;

  .footer-content {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    gap: 60px;
    margin-bottom: 40px;

    .footer-logo {
      .logo {
        font-size: 24px;
        font-weight: bold;
        color: #ff6b35;
        margin-bottom: 30px;
      }

      .qrcode {
        text-align: center;

        img {
          width: 120px;
          height: 120px;
          margin-bottom: 10px;
        }

        p {
          font-size: 14px;
          color: #999;
        }
      }
    }

    .footer-links {
      display: flex;
      gap: 80px;

      .link-group {
        h3 {
          font-size: 18px;
          margin-bottom: 20px;
          color: #fff;
        }

        ul {
          list-style: none;
          padding: 0;

          li {
            margin-bottom: 12px;

            a {
              color: #999;
              text-decoration: none;
              transition: color 0.3s;

              &:hover {
                color: #ff6b35;
              }
            }
          }
        }
      }
    }
  }

  .footer-bottom {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 20px;
    text-align: center;

    p {
      color: #666;
      font-size: 14px;
    }
  }
}

// 响应式适配
@media screen and (max-width: 992px) {
  .footer-section {
    .footer-content {
      flex-direction: column;
      gap: 40px;

      .footer-logo {
        text-align: center;
      }

      .footer-links {
        justify-content: center;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .footer-section {
    padding: 40px 20px 20px;

    .footer-content {
      .footer-links {
        flex-direction: column;
        gap: 30px;
        text-align: center;
      }
    }
  }
}
</style>


<style lang="less">
:deep(.el-carousel__arrow) {
  background-color: #ff6b35;
  border-radius: 50%;

  &:hover {
    background-color: #ff8255;
  }
}

:deep(.el-carousel__container) {
  height: 80px;
}
</style>